import { TOUR_TRANSLATIONS } from "../translations"

export const getAssortmentSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="assortment-filters"]',
            title: t.assortmentFilters.title,
            content: t.assortmentFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="assortment-widgets"]',
            title: t.assortmentWidgets.title,
            content: t.assortmentWidgets.content,
        },
        {
            target: '[data-tour="assortment-table"]',
            title: t.assortmentTable.title,
            content: t.assortmentTable.content,
        },
        {
            target: '[data-tour="assortment-footer"]',
            title: t.assortmentFooter.title,
            content: t.assortmentFooter.content,
        },
    ]
}
